import { FC, useMemo } from 'react'
import { Report } from 'common/Report/Report'
import { ChartData, ChartOptions } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import { WithReportLoader } from 'common/WithLoader/WithLoader'
import { useGetCreatedQueryReportByTenantQuery } from 'services/api/queryApi'
import { ChartReportItem } from 'types'

const getConfig = (): ChartOptions => ({
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'bottom'
    }
  },
  scales: {
    x: {
    },
    y: {
    }
  }
})

const initialChartData = (categoryPercentage?: number): ChartData => ({
  labels: [],
  datasets: [
    {
      label: 'opened items',
      backgroundColor: '#ff6961',
      maxBarThickness: 30,
      categoryPercentage,
      data: []
    }
  ]
})

const chartData = (data: ChartReportItem[]): ChartData => {
  const dataLength = data.length
  const addCategoryThickness = dataLength < 10
  return data.reduce<ChartData>((cd, { unit, value }) => {
    cd.labels?.push(`${unit}`)
    cd.datasets[0].data.push(value)
    return cd
  }, initialChartData(addCategoryThickness ? dataLength * 0.1 : 1))
}

export const CreatedQueryBarChartReport: FC<{tenantId: string}> = ({ tenantId }) => {
  const { data: queryReport, isLoading } = useGetCreatedQueryReportByTenantQuery(tenantId)

  const ChartElement = useMemo(() => {
    return <Bar type={'bar'} data={chartData(queryReport ?? [])} options={getConfig()} />
  }, [queryReport, getConfig()])

  return (
    <Report
      title={'Open items per month'}
      info={'Number of created items per month for current year.'}>
      <WithReportLoader
        noWrapper
        loading={isLoading}
        hasResults={true}>
        {ChartElement}
      </WithReportLoader>
    </Report>
  )
}
